import { render, staticRenderFns } from "./cargoPortDetail.vue?vue&type=template&id=748812ca"
import script from "./cargoPortDetail.vue?vue&type=script&lang=js"
export * from "./cargoPortDetail.vue?vue&type=script&lang=js"
import style0 from "./cargoPortDetail.vue?vue&type=style&index=0&id=748812ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports